"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var FormItem_1 = __importDefault(require("../FormItem"));
var TreeNode = antd_1.TreeSelect.TreeNode;
var InputTreeSelect = function (props) {
    var _a = react_1.useState(), valueTree = _a[0], setValueTree = _a[1];
    var name = props.name, label = props.label, span = props.span, validate = props.validate, validateSchema = props.validateSchema, required = props.required, data = props.data, multiple = props.multiple, place = props.place, expand = props.expand, icon = props.icon, afterIcon = props.afterIcon, selectProps = __rest(props, ["name", "label", "span", "validate", "validateSchema", "required", "data", "multiple", "place", "expand", "icon", "afterIcon"]);
    var onChange = function (value) {
        setValueTree(value);
    };
    var getNodes = function (item) {
        var result = [];
        item.map(function (child) {
            if (child.filhas.length > 0) {
                result.push(react_1.default.createElement(TreeNode, { title: child.descricao, value: child.descricao + "#-#" + child.codigo, key: "" + child.codigo }, getNodes(child.filhas)));
            }
            else {
                result.push(react_1.default.createElement(TreeNode, { title: child.descricao, value: child.descricao + "#-#" + child.codigo, key: "" + child.codigo }));
            }
        });
        return result;
    };
    return (react_1.default.createElement(FormItem_1.default, __assign({}, { name: name, label: label, span: span, validate: validate, validateSchema: validateSchema, required: required }),
        react_1.default.createElement(contexts_1.PermissionContext.Consumer, null, function (_a) {
            var allowEdit = _a.allowEdit;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(antd_1.TreeSelect, __assign({ showSearch: true, multiple: multiple, style: { width: icon ? 'calc(100% - 50px)' : '100%' }, placeholder: !place ? 'Select item...' : place, dropdownStyle: { maxHeight: 400, overflow: 'auto' }, onChange: onChange, value: valueTree, disabled: !allowEdit, allowClear: true, treeDefaultExpandAll: expand }, selectProps), getNodes(data)),
                icon && afterIcon));
        })));
};
exports.default = InputTreeSelect;
